module.exports = __webpack_public_path__ + "static/media/citroen.0f1e56fb.svg";